// login
export const LOGIN_ADMIN = "LOGIN_ADMIN";
export const GET_ADMINS = "GET_ADMINS";
export const SIGNUP_ADMIN = "SIGNUP_ADMIN";

//LogOut_admin
export const LOGOUT_ADMIN = "LOGOUT_ADMIN";

// get profile
export const PROFILE_ADMIN = "PROFILE_ADMIN";

//  admin profile update
export const UPDATE_PROFILE = "UPDATE_PROFILE";

// Change Password
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";

// Update Image Profile
export const UPDATE_IMAGE_PROFILE = "UPDATE_IMAGE_PROFILE";

export const ADD_ADMIN = "ADD_ADMIN";
export const EDIT_ADMIN = "EDIT_ADMIN";
export const DELETE_ADMIN = "DELETE_ADMIN";
export const BLOCK_ADMIN = "BLOCK_ADMIN";
